import React, { FC } from 'react'
import { DefaultPage } from '@tnwinc/navex-react'
import { Spinner } from '../Shared/Spinner'
import { UnexpectedError } from '../Shared/Error'
import { useGetEmployeeCountInfo } from './EmployeeCountApi'
import { TOGGLENAME } from '../../ts/enums/releaseToggles'
import { ManageEmployeeCount } from './ManageEmployeeCount'

interface IProps {
    toggles: string[]
}

export const EmplloyeeCountRoute: FC<IProps> = (props) => {

    const [{ employeeCountInfo, loading, errors, status }, reFetchData] = useGetEmployeeCountInfo(props.toggles.includes(TOGGLENAME.BENCHMARKINGCOMPONENT))
    if (errors.length) return <UnexpectedError />
    if (loading || !status) return <Spinner />

    return (<DefaultPage>
        <ManageEmployeeCount employeeCountInfo={employeeCountInfo} refetch={reFetchData} />
    </DefaultPage>)
}